/*
  DON'T import this file directly, import src/graphql/index.js into your deps
  When you need to modify a query or fragment, modify the .graphql files - NOT the __generated__ files
  Each time you modify a GraphQL file, the node_modules/.cache/babel-loader folder must be cleared for the changes to take effect
*/

import { type GraphQLRequestParams } from '../types';

import { Templates } from './__generated__';

interface IQueryRequestVariables {
  // TODO WEBCA-1926: Remove this option and its references after curator project launches
  withCollaborations?: boolean;
}

interface IQueryRequestVariableGetDetails extends IQueryRequestVariables {
  pandoraId: string;
}

interface IQueryRequestVariableGetAnnotations extends IQueryRequestVariables {
  pandoraIds: string[];
}

const getArtistDetails = (
  requestVariables: IQueryRequestVariableGetDetails,
): GraphQLRequestParams<IQueryRequestVariableGetDetails> => {
  const { pandoraId, withCollaborations } = requestVariables;

  return {
    operationKeyName: withCollaborations
      ? 'GET_ARTIST_DETAILS_WITH_COLLABORATIONS'
      : 'GET_ARTIST_DETAILS',
    query: withCollaborations
      ? Templates.GetArtistDetailsWithCollaborations
      : Templates.GetArtistDetails,
    variables: { pandoraId },
  };
};

const getArtistCollaborations = (
  requestVariables: IQueryRequestVariableGetDetails,
): GraphQLRequestParams<IQueryRequestVariableGetDetails> => {
  const { pandoraId } = requestVariables;
  return {
    operationKeyName: 'GET_ARTIST_COLLABORATIONS',
    query: Templates.GetArtistCollaborations,
    variables: { pandoraId },
  };
};

const getComposerDetails = (
  requestVariables: IQueryRequestVariableGetDetails,
): GraphQLRequestParams<IQueryRequestVariableGetDetails> => {
  const { pandoraId } = requestVariables;
  return {
    operationKeyName: 'GET_COMPOSER_DETAILS',
    query: Templates.GetComposerDetails,
    variables: { pandoraId },
  };
};

const getStationCurators = (
  requestVariables: IQueryRequestVariableGetAnnotations,
): GraphQLRequestParams<IQueryRequestVariableGetAnnotations> => {
  const { pandoraIds } = requestVariables;
  return {
    operationKeyName: 'GET_STATION_CURATORS',
    query: Templates.GetStationCurators,
    variables: { pandoraIds },
  };
};

const getPlaylistCurators = (
  requestVariables: IQueryRequestVariableGetAnnotations,
): GraphQLRequestParams<IQueryRequestVariableGetAnnotations> => {
  const { pandoraIds } = requestVariables;
  return {
    operationKeyName: 'GET_PLAYLIST_CURATORS',
    query: Templates.GetPlaylistCurators,
    variables: { pandoraIds },
  };
};

const getGenreCurators = (
  requestVariables: IQueryRequestVariableGetAnnotations,
): GraphQLRequestParams<IQueryRequestVariableGetAnnotations> => {
  const { pandoraIds } = requestVariables;
  return {
    operationKeyName: 'GET_GENRE_CURATORS',
    query: Templates.GetGenreCurators,
    variables: { pandoraIds },
  };
};

export default {
  getArtistCollaborations,
  getArtistDetails,
  getComposerDetails,
  getGenreCurators,
  getPlaylistCurators,
  getStationCurators,

  // deprecated WEBCA-2418 - the exports below are for queries that use the deprecated UrqlClient.
  // Instead of exporting templates, please use the pattern above of creating a requestParams functions.
  getAlbumDetails: Templates.GetAlbumDetails,
  getArtistDetailsWithCurators: Templates.GetArtistDetailsWithCurators,
  getCuratorDetails: Templates.GetCuratorDetails,
  getPlaylistCurator: Templates.GetPlaylistCurator,
  getRecentlyPlayedSources: Templates.GetRecentlyPlayedSources,
  getStationCurator: Templates.GetStationCurator,
};
